import './index.scss';
const AmlPolicy = () => {
	return (
		<div className="amlPolicy">
			<div className="content">
				<div className="title">POLÍTICA PLD/CFTP SITE</div>
				<div className="textItem">
					<p>
						<b>1. Disposições Gerais</b>
					</p>

					<p>
						A EB Intermediações e Jogos S.A. (“EstrelaBet”) está totalmente empenhada e
						constantemente vigilante para prevenir a lavagem de dinheiro e combater o financiamento
						do terrorismo de forma a minimizar e gerir riscos de seus negócios, oferecendo a maior
						segurança possível dentro de sua operação.
					</p>

					<p>
						A EstrelaBet está comprometida com seu dever social de promover um ambiente seguro e
						íntegro, adotando medidas rigorosas para prevenir crimes e garantindo que seus sistemas
						não sejam utilizados, de forma direta ou indireta, como meio para facilitar atividades
						ilícitas.
					</p>

					<p>
						A EstrelaBet se esforçará para manter-se atualizada com os desenvolvimentos nos âmbitos
						nacional e internacional sobre quaisquer iniciativas que visam prevenir a lavagem de
						dinheiro e o financiamento do terrorismo.
					</p>

					<p>
						Esta política de Prevenção à Lavagem de Dinheiro e Combate ao Financiamento do
						Terrorismo e da Proliferação de Armas (PLD/CFTP) é fundamentada em uma abordagem baseada
						em risco, visando identificar, avaliar e mitigar os riscos inerentes às atividades
						realizadas pela EstrelaBet. Essa abordagem considera fatores como o perfil dos usuários,
						o volume financeiro das operações, a natureza dos produtos e serviços oferecidos, além
						dos riscos associados a funcionários, parceiros, prestadores de serviços e demais partes
						interessadas que possam impactar direta ou indiretamente a conformidade com as
						obrigações legais e regulatórias aplicáveis ao setor de aposta de quota fixa, como a Lei
						nº 9.613/1998 e Portaria SPA/MF nº 1.143/2024.
					</p>

					<p>
						<b>2. Conceitos</b>
					</p>

					<p>
						Para maior entendimento, a EstrelaBet apresenta, a seguir, os principais conceitos
						relacionados ao tema.
					</p>

					<p>
						A lavagem de dinheiro (LD) refere-se ao processo de disfarce da origem ilícita de
						recursos financeiros obtidos por meio de atividades criminosas, de modo que pareçam
						legítimos. Quando bem-sucedida, essa prática permite que os envolvidos continuem
						controlando os valores e os utilizem livremente sem levantar suspeitas. O processo de LD
						normalmente ocorre em três etapas principais: (i) colocação: introdução do dinheiro
						obtido de forma ilícita no sistema financeiro por meio de depósitos, compra de ativos ou
						outras operações; (ii) ocultação: realização de transações complexas para dificultar o
						rastreamento dos recursos, visando quebrar o vínculo entre o dinheiro e sua origem
						criminosa. (iii) integração: uso dos fundos já "limpos" em atividades econômicas legais,
						dando aparência de legitimidade aos recursos.
					</p>

					<p>
						O financiamento do terrorismo (FT) consiste no fornecimento de suporte financeiro a
						indivíduos, grupos ou organizações envolvidos em atividades terroristas. Diferentemente
						da lavagem de dinheiro, os recursos utilizados no financiamento do terrorismo podem ser
						tanto de origem ilícita quanto lícita. Nesse contexto, o foco dos financiadores é
						ocultar a finalidade dos valores e os canais utilizados, em vez de disfarçar a sua
						origem.
					</p>

					<p>
						Por sua vez, o financiamento da proliferação de armas de destruição em massa (P)
						refere-se às operações que facilitam a transferência, venda ou exportação de armas
						nucleares, químicas ou biológicas, incluindo seus componentes e tecnologias
						relacionadas. Esse tipo de financiamento, frequentemente associado a grupos terroristas,
						adota métodos semelhantes aos utilizados na lavagem de dinheiro para evitar a detecção
						pelas autoridades regulatórias.
					</p>

					<p>
						<b>3. Controles e Procedimentos de PLD/FT</b>
					</p>

					<p>
						A EstrelaBet reafirma seu compromisso em adotar práticas eficazes de Prevenção à Lavagem
						de Dinheiro e Combate ao Financiamento do Terrorismo (PLD/FT), protegendo a integridade
						de suas operações, sua reputação e contribuindo ativamente para a segurança do setor de
						apostas online. A Empresa busca continuamente aprimorar seus controles internos e
						procedimentos de acordo com as regulamentações locais e internacionais, adotando uma
						abordagem baseada em risco para mitigar ameaças relacionadas a atividades criminosas.
					</p>

					<p>
						<b>3.1 Avaliação de Riscos e Procedimento KYC (Conheça Seu Cliente)</b>
					</p>

					<p>
						A EstrelaBet adota um rigoroso processo de Avaliação de Riscos e Due Diligence para
						conhecer seus clientes (KYC), coletando, verificando e armazenando informações
						cadastrais de todos os usuários de sua plataforma. Esse processo é contínuo e visa
						identificar, qualificar e classificar os riscos de LD/FT associados a cada usuário,
						assegurando que as medidas de controle sejam proporcionais ao perfil de risco
						identificado.
					</p>

					<p>
						A Avaliação de Riscos considera fatores como a origem dos fundos, o histórico
						transacional e a região geográfica dos usuários, permitindo à EstrelaBet aplicar
						controles internos específicos e monitorar transações atípicas ou suspeitas. Dependendo
						do nível de risco identificado, podem ser implementadas medidas adicionais de diligência
						e monitoramento reforçado.
					</p>

					<p>
						Além disso, a EstrelaBet realiza diligências reputacionais, incluindo a consulta a
						listas de sanções e outros mecanismos que garantam a conformidade com as exigências
						regulatórias. A classificação de risco dos usuários é revisada regularmente ou sempre
						que houver mudanças significativas no perfil cadastral ou nas atividades transacionais.
					</p>

					<p>
						Reconhecendo a importância da proteção de dados pessoais e informações sensíveis, a
						EstrelaBet assegura que todos os procedimentos de análise de riscos sejam devidamente
						documentados, armazenados de forma segura e tratados em conformidade com as legislações
						aplicáveis, como a Lei Geral de Proteção de Dados (LGPD).
					</p>

					<p>
						<b>
							3.2 Avaliação de Riscos – Colaboradores, Fornecedores, Parceiros e Prestadores de
							Serviços
						</b>
					</p>

					<p>
						Além da avaliação de riscos para potenciais clientes, a EstrelaBet conduz procedimentos
						de diligência e critérios para contratação de funcionários-chave, parceiros e
						prestadores de serviços, no que tange a questões reputacionais, incluindo, métricas para
						se avaliar eventuais riscos que estes terceiros possuam em relação à PLD/FT. É conduzida
						também verificação de risco das instituições financeiras ou de pagamento que prestam
						serviço para a EstrelaBet, nos termos da regulamentação vigente. Os dados das partes
						interessadas são coletados e mantidos atualizados mediante perfil de risco.
					</p>

					<p>
						<b>
							3.3 Identificação, Avaliação, Análise e Mitigação de Riscos em Novos Produtos,
							Serviços e Tecnologias
						</b>
					</p>

					<p>
						A EstrelaBet compromete-se a identificar, avaliar, analisar e mitigar os riscos
						relacionados à possibilidade de que novos produtos, serviços ou tecnologias possam ser
						utilizados para a prática de Lavagem de Dinheiro (LD), Financiamento ao Terrorismo (FT),
						e proliferação de Armas de Destruição em Massa, bem como outros delitos correlatos.
					</p>

					<p>
						<b>3.4 Avaliação Interna de Riscos</b>
					</p>

					<p>
						A EstrelaBet realiza avaliação interna de riscos. Para identificação dos riscos, a
						avaliação interna considera, no mínimo, seguindo as disposições da Portaria SPA/MF nº
						1.143/23, os perfis de risco:
					</p>

					<ul>
						<li>de apostadores e usuários da plataforma;</li>
						<li>
							da própria EstrelaBet, levando em conta a especificidade do seu modelo de negócio;
						</li>
						<li>de funcionários, colaboradores, fornecedores e parceiros terceirizados;</li>
						<li>
							de operações, produtos e serviços, levando em conta canais de distribuição e
							utilização de tecnologias.
						</li>
					</ul>

					<p>
						Por sua vez, há também verificação periódica da efetividade da política adotada e da
						aderência à regulação governamental que contemple a identificação e a correção de
						deficiências verificadas.
					</p>

					<p>Serão testados no mínimo:</p>

					<ul>
						<li>
							Identificação, qualificação e classificação de risco de apostadores e usuários da
							plataforma;
						</li>
						<li>
							Identificação, qualificação e classificação de risco de funcionários, parceiros e
							prestadores de serviços terceirizados;
						</li>
						<li>
							Avaliação e classificação de risco de suas atividades relativas à operacionalização de
							apostas considerando fatores de riscos na avaliação de novos produtos;
						</li>
						<li>
							Avaliação e classificação de risco em suas atividades negociais, contratação e
							desenvolvimento de produtos;
						</li>
						<li>
							Programa de conformidade que contemple disseminação de cultura organizacional de
							prevenção à LD/FTP e atividades de informação e capacitação em matérias de prevenção à
							LD/FTP;
						</li>
						<li>
							Verificação periódica e monitoramento da conformidade das instituições de pagamento e
							instituições financeiras com as quais EstrelaBet mantenha relacionamento;
						</li>
						<li>
							Monitoramento, seleção e análise de operações e atividades, relativas ou não à
							operacionalização de apostas, para fins de comunicação ao COAF, nas hipóteses do
							inciso II do art. 11 da Lei nº 9.613, de 1998, bem como de realização das comunicações
							previstas no art. 11 e no parágrafo único do art. 12 da Lei nº 13.810, de 2019;
						</li>
						<li>
							Registro e manutenção de informações relativas às suas atividades operacionais,
							negociais e de administração;
						</li>
						<li>Manutenção de cadastro atualizado de apostadores e usuários da plataforma;</li>
						<li>
							Manutenção de cadastro atualizado de funcionários, parceiros e prestadores de serviços
							terceirizados;
						</li>
						<li>Atualização e aprovação da Política e do Procedimento PLD-CFT.</li>
					</ul>

					<p>
						<b>3.5 Identificação dos Beneficiários Finais</b>
					</p>

					<p>
						A EstrelaBet não aceita a abertura de Contas anônimas ou com nomes fictícios de forma
						que o verdadeiro beneficiário não seja conhecido.
					</p>

					<p>
						Dessa forma, a EstrelaBet promove diligências para a identificação dos destinatários
						finais, objetivando a prevenção à lavagem de dinheiro e do financiamento do terrorismo.
					</p>

					<p>
						A EstelaBet prioriza o relacionamento transparente com seus clientes e usuários. Dessa
						forma, não é possível abertura de contas para Pessoas Jurídicas ou representantes de
						pessoas físicas, bem como depósitos provenientes de Pessoas Jurídicas.
					</p>

					<p>
						<b>
							3.6 Avaliação e Classificação de Risco nas Atividades de Operacionalização de Apostas
							e Atividades Negociais
						</b>
					</p>

					<p>
						A EstrelaBet possui procedimentos para a avaliação e classificação de risco em suas
						atividades de operacionalização de apostas, visando mitigar riscos associados à Lavagem
						de Dinheiro (LD) e ao Financiamento ao Terrorismo (FT). A empresa utiliza metodologias
						de análise de risco para categorizar suas operações com base em critérios de
						criticidade, considerando fatores como o volume de apostas, o perfil dos usuários e o
						comportamento transacional. Esses procedimentos garantem o monitoramento contínuo das
						atividades, com revisões periódicas para ajustar as medidas de controle interno.
					</p>

					<p>
						Para além da análise de risco de novos produtos e de novos parceiros, a EstrelaBet
						realiza a avaliação e classificação de risco nas suas atividades negociais, incluindo
						operações com ativos financeiros e imobiliários.
					</p>

					<p>
						<b>3.7 Pessoas Politicamente Expostas – “PEPs”</b>
					</p>

					<p>
						Pessoas politicamente expostas - PEP, são indivíduos que ocupam ou ocuparam cargos
						públicos importantes ou de destaque em governos, organizações internacionais, partidos
						políticos ou empresas estatais. Essas pessoas são analisadas com mais rigor, devido ao
						acesso privilegiado a recursos e informações sensíveis, o que internacionalmente é
						destinado a controles mais sofisticados relacionados à PLD/CFTP. Por isso, as empresas
						do setor financeiro e outras organizações são obrigadas a tomar medidas adicionais de
						monitoramento e diligência na hora de realizar transações ou negócios com clientes PEP.
					</p>

					<p>
						<b>
							3.8 Indisponibilidade de Ativos Oriundos do Conselho de Segurança das Nações Unidas
							(“CSNU”)
						</b>
					</p>

					<p>
						A EstrelaBet se compromete em adotar procedimentos para cumprimento, nos termos do art.
						9º da Lei n º 13.810, de 2019, resoluções do CSNU ou designações que determinem a
						indisponibilidade de ativos de titularidade, direta ou indiretamente, de pessoas
						físicas, jurídicas ou de entidades que estejam submetidas a sanções decorrentes de tais
						designações.
					</p>

					<p>
						<b>3.9 Monitoramento de Transações - Situações Suspeitas</b>
					</p>

					<p>
						As operações e transações realizadas no site são monitoradas para evitar atividades de
						lavagem de dinheiro ou financiamento do terrorismo. A EstrelaBet adota mecanismos
						eficazes para garantir que situações atípicas, suspeitas ou que apresentem alto grau de
						risco de Lavagem de Dinheiro (LD) e Financiamento do Terrorismo (FT) sejam devidamente
						analisadas e, quando necessário, reportadas às autoridades competentes, em conformidade
						com a legislação vigente.
					</p>

					<p>
						Se o nosso Departamento de Riscos identificar uma situação ou transação que levante
						suspeitas de LD/FT, pode ser necessário que o usuário forneça a documentação apropriada.
						Se houver indícios suficientes de comportamento embasar a suspeito, a conta poderá ser
						encerrada ou suspensa.
					</p>

					<p>
						Sem prejuízo a eventual suspensão da conta, poderá ser realizada comunicação de operação
						suspeita ao COAF via SISCOAF juntamente com os respectivos fundamentos (provas) no prazo
						de 24 horas a partir da decisão de comunicação pela Companhia.
					</p>

					<p>
						<b>4. MLRO</b>
					</p>

					<p>
						O MLRO, ou Responsável por Prevenção à Lavagem de Dinheiro, desempenha um papel central
						no programa de compliance da EstrelaBet, sendo o ponto focal das ações de combate à
						lavagem de dinheiro e ao financiamento do terrorismo. Esse profissional é responsável
						por garantir que a política de PLD/FT da empresa esteja sendo implementada de forma
						eficaz, liderando o desenvolvimento, a atualização e a execução de procedimentos
						internos que visem mitigar riscos associados a atividades ilícitas. O MLRO também
						supervisiona os mecanismos de controle da EstrelaBet, assegurando que as transações
						sejam monitoradas e que atividades suspeitas sejam prontamente comunicadas às
						autoridades competentes, como o COAF.
					</p>

					<p>
						Além disso, o MLRO é fundamental para a criação de uma cultura organizacional de
						conformidade e integridade. Esse responsável deve promover a conscientização contínua
						sobre as obrigações de PLD/FT por meio de treinamentos e capacitações, garantindo que
						todos os colaboradores, parceiros e prestadores de serviço compreendam suas
						responsabilidades e saibam como identificar e reportar possíveis riscos. Cabe ao MLRO
						assegurar que os processos de avaliação de risco sejam devidamente documentados e que
						relatórios gerenciais sejam apresentados periodicamente à Diretoria, incluindo
						recomendações para aprimorar os controles internos e corrigir eventuais deficiências
						identificadas.
					</p>

					<p>
						<b>5. Integridade e Treinamentos</b>
					</p>

					<p>
						Como parte fundamental de seu programa de compliance, a EstrelaBet promoverá
						regularmente sessões de treinamento e capacitação voltadas para todos os seus
						colaboradores e parceiros relevantes. Esses treinamentos têm como objetivo garantir que
						todos estejam atualizados sobre os requisitos legais e regulatórios aplicáveis, bem como
						sobre as melhores práticas e ferramentas utilizadas no combate à lavagem de dinheiro e
						ao financiamento do terrorismo. As sessões de treinamento também reforçarão a
						importância de reportar atividades suspeitas e de manter uma postura vigilante em todas
						as operações.
					</p>

					<p>
						Esta Política de Prevenção à Lavagem de Dinheiro e ao Financiamento ao Terrorismo
						(PLD/FT) é um componente essencial do Programa de Compliance da EstrelaBet. Seu objetivo
						é promover a disseminação de uma cultura organizacional voltada à prevenção de LD/FTP e
						outros delitos correlatos, assegurando a integridade, a boa governança e a adesão à
						agenda ASG (ambiental, social e governança). Em conformidade com os princípios da Lei nº
						12.846, de 1º de agosto de 2013, a EstrelaBet implementa e executa um programa robusto
						que abrange colaboradores, parceiros e prestadores de serviços terceirizados, garantindo
						que todos estejam alinhados com as melhores práticas de conformidade e ética corporativa
						no mercado de apostas de quota fixa.
					</p>

					<p>
						A EstrelaBet está sempre disponível para ouvir seus usuários e garantir um ambiente
						seguro e transparente em suas operações. Caso tenha dúvidas, preocupações ou sugestões
						relacionadas à política de Prevenção à Lavagem de Dinheiro e Combate ao Financiamento do
						Terrorismo, encorajamos nossos clientes a entrarem em contato diretamente com o
						departamento de atendimento ao cliente por meio do link:
						https://estrelabet.zendesk.com/hc/pt-br Nossa equipe está pronta para atender e
						esclarecer quaisquer questões que possam surgir.
					</p>

					<p>
						<b>DATA DE PUBLICAÇÃO:</b> 01/01/2025
					</p>

					<p>
						<b>VERSÃO:</b> 1.0
					</p>
				</div>
			</div>
		</div>
	);
};
export default AmlPolicy;
